/**
 * Nuvora custom overrides — additive only. Never edits Appstle's or the theme's
 * own JS; only reacts to what they render, via polling + insertion.
 *
 * Adds a small Italian notice next to the Appstle "Subscribe & Save" purchase
 * option, explaining that the bundle discount (from "Leve mais pagando menos")
 * keeps applying on every future renewal, not just the first order. This exists
 * because customers were confused: the checkout's own "Subtotale ricorrente"
 * line shows the undiscounted price by Shopify design (platform limitation,
 * cannot be changed on a non-Plus plan — see reference/subscriptions.md), so a
 * plain-language reassurance next to the purchase option reduces that friction
 * without touching checkout itself.
 */
(function () {
  var NOTICE_TEXT =
    "Lo sconto della quantità selezionata sopra si applica anche a tutti i rinnovi futuri dell'abbonamento: il prezzo scontato resta invariato ogni mese.";
  var NOTICE_CLASS = 'nuvora-subscription-discount-notice';
  var TARGET_SELECTOR = '.appstle_subscribe_option';

  function alreadyInserted(target) {
    return target.parentElement.querySelector('.' + NOTICE_CLASS) !== null;
  }

  function insertNotice(target) {
    if (alreadyInserted(target)) return;
    var p = document.createElement('p');
    p.className = NOTICE_CLASS;
    p.textContent = NOTICE_TEXT;
    p.style.cssText =
      'margin: 8px 0 0; font-size: 12px; line-height: 1.4; color: var(--color-foreground, #6b6b6b); opacity: 0.75;';
    target.insertAdjacentElement('afterend', p);
  }

  function tryInsert() {
    var target = document.querySelector(TARGET_SELECTOR);
    if (target) insertNotice(target);
  }

  // Appstle's widget renders asynchronously (and can re-render on variant /
  // purchase-option changes), so poll briefly instead of relying on a single
  // DOMContentLoaded pass. MutationObserver on <body> covers later re-renders.
  var attempts = 0;
  var poll = setInterval(function () {
    tryInsert();
    attempts += 1;
    if (attempts > 40) clearInterval(poll); // ~20s ceiling
  }, 500);

  new MutationObserver(tryInsert).observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
